import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    Stack,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchOrdersByCustomerId } from "../../redux/orderSlice";
import { formatDateWithSlash } from "../../utilities/date-utility";
import { handlePayment } from "../../utilities/paymentUtils";
import { Loader } from "../loader/loader";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

type Props = {};

const OrderHistory: React.FC<Props> = ({ }) => {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const [orders, setOrders] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setIsLoading(false);
    }

    const statusColors = {
        green: ['CONFIRMED', 'DELIVERED'],
        red: ['CANCELLED', 'RETURNED', 'REFUNDED', 'FAILED'],
        gray: ['PENDING', 'PROCESSING'],
        blue: ['SHIPPED', 'OUT_FOR_DELIVERY'],
    };

    const getColor = (status: any) => {
        for (const [color, statuses] of Object.entries(statusColors)) {
            if (statuses.includes(status)) {
                return color;
            }
        }
        return 'gray';
    };

    useEffect(() => {
        fetchOrders();
    }, [])

    const fetchOrders = async () => {
        if (!isLoading) { setIsLoading(true); }
        const response = await dispatch(fetchOrdersByCustomerId()).unwrap();
        setIsLoading(false);
        setOrders(response);
    }

    const handleViewOrderDetails = (orderId: string) => {
        navigate("/view", { state: { orderId } });
    }
    const handleTrackOrder = () => {
        navigate("/tracknow");
    }

    return (
        <>
            <Loader loading={isLoading} handleClose={handleClose} />
            <Accordion defaultExpanded={true}
                style={{ marginTop: (HEIGHT * 4) / 100, borderRadius: 14, backgroundColor: '#f8f3f3', border: '1px solid #7a7272' }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    style={{ padding: (WIDTH * 1) / 100 }}
                >
                    <Grid item xs={12} md={12} style={{ display: "flex" }}>
                        <img src={require("../../../assets/maps.png")} width={30} height={30} />
                        <Typography variant="h5" style={{ marginLeft: "20px" }}>
                            Order History
                        </Typography>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Box p={1}>
                        <Stack spacing={3}>
                            {orders.map((order) => (
                                <Card key={order.id} variant="outlined">
                                    <CardContent>
                                        <Box display="flex" mb={2}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6} md={6} style={{ display: "flex" }}>
                                                    <Typography variant="h6">
                                                        Order #{order.orderNumber}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} md={6} style={{ display: "flex", justifyContent: 'end' }}>
                                                    <Typography variant="h6" color="primary">
                                                        ${order.totalAmount}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6} md={6} style={{ display: "flex" }}>
                                                <Typography variant="body2" color="textSecondary" gutterBottom>
                                                    Ordered on {formatDateWithSlash(order.orderDate)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} md={6} style={{ display: "flex", justifyContent: 'end' }}>
                                                <Typography variant="h6" color="primary">
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            display: 'inline-block',
                                                            padding: '4px 8px',
                                                            borderRadius: '12px',
                                                            backgroundColor: getColor(order.orderStatus),
                                                            color: 'white',
                                                            fontSize: '0.75rem',
                                                            fontWeight: 700,
                                                            textTransform: 'capitalize',
                                                        }}
                                                    >
                                                        {order.orderStatus}
                                                    </Box>
                                                    {order.paymentStatus && order.paymentStatus == 'PENDING' &&
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                display: 'inline-block',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                marginLeft: '5px',
                                                                backgroundColor: '#c72a22',
                                                                color: 'white',
                                                                fontSize: '0.75rem',
                                                                fontWeight: 700,
                                                                textTransform: 'capitalize',
                                                            }}
                                                        >
                                                            PAYMENT {order.paymentStatus}
                                                        </Box>
                                                    }
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ my: 2, bgcolor: "primary.main" }} />
                                        {order.orderItems.map((item: any, index: number) => (
                                            <Box key={index} mb={1} display="flex" justifyContent="space-between" borderRadius="10">
                                                <Typography>
                                                    {item.product.productName} (x{item.quantity})
                                                </Typography>
                                                <Typography>{item.totalPrice}</Typography>
                                            </Box>
                                        ))}
                                        <Divider sx={{ my: 2 }} />
                                        <Box display="flex" gap={2} mt={2}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                onClick={() => handleViewOrderDetails(order.orderId)}
                                            >
                                                View Order Details
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                onClick={handleTrackOrder}
                                            >
                                                Track Order
                                            </Button>
                                            {order.paymentStatus && order.paymentStatus == 'PENDING' && <Button
                                                variant="outlined"
                                                color="success"
                                                size="small"
                                                onClick={() => handlePayment(order, navigate)}
                                            >
                                                Retry payment
                                            </Button>}
                                        </Box>
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>

    );
};

export default OrderHistory;
